module.exports = __webpack_public_path__ + "img/piggy_bank_coin.5c275c87.png";